var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LoadingContext',{ref:"vFormRoot",staticClass:"child-avatar-editable-root relative",attrs:{"loading":_vm.loading}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"flex flex-col justify-center child-avatar-outer"},[_c('AvatarEditable',{staticClass:"w-7/10 mx-auto xs:w-8/10",attrs:{"imageUrl":_vm.childPhotoUrl,"imageAlt":"Zdjęcie podopiecznego","editButtonAlt":"Edytuj zdjęcie podopiecznego","editable":_vm.showEdit,"hasPhoto":_vm.child.hasPhoto,"isProfileVerified":_vm.child.is_profile_verified},on:{"start_editing":function($event){return _vm.$refs.contextMenu.$emit('open', $event)},"open_preview":function($event){return _vm.$refs.photoPreview.$emit('open_preview', {photo_url: _vm.child.photoUrl})}}}),_vm._v(" "),_c('div',[_c('PrettyContextMenu',{ref:"contextMenu",staticClass:"w-0 mx-auto",attrs:{"position":"left","menuItems":[{
          id: 1,
          text: 'Wybierz nowe zdjęcie profilowe',
          icon_src: '/images/icons/open-photo-profile-desktop.svg',
          action: () => {
            _vm.openProfilePhotoInput();
          },
        }, {
          id: 2,
          text: 'Wyświetl zdjęcie profilowe',
          icon_src: '/images/icons/add-change-photo-profile-desktop.svg',
          hidden: !_vm.child.hasPhoto,
          action: () => {
            _vm.$refs.contextMenu.$emit('close');
            _vm.$refs.photoPreview.$emit('open_preview', {photo_url: _vm.child.photoUrl});
          }
        }, {
          id: 3,
          text: 'Wykadruj zdjęcie profilowe',
          icon_src: '/images/icons/open-photo-profile-desktop.svg',
          hidden: !_vm.child.hasPhoto,
          action: () => {
            _vm.$refs.contextMenu.$emit('close');
            // $refs.photoCropper.$emit('open', {photo_url: child.photoUrl});
            _vm.$refs.photoCropper.$emit('open', _vm.child.photoUrl);
          }
        }]}})],1)],1),_vm._v(" "),_c('PhotoPreview',{ref:"photoPreview",staticClass:"photo-preview-small",attrs:{"actions":_vm.showEdit ? [{
      id: 1,
      text: 'Usuń zdjęcie profilowe',
      class: 'action-list-btn usun-zdjecie-btn',
      action: () => _vm.confirm('Usunąć zdjęcie profilowe?') && _vm.$emit('remove_profile_photo')
    }] : [],"arrows":false}}),_vm._v(" "),(_vm.MODE === 'cropper')?_c('PhotoCropper',{ref:"photoCropper",on:{"croppedBlob":_vm.onCroppedPhoto}}):_vm._e(),_vm._v(" "),(_vm.showEdit)?_c('form',{staticClass:"w-full xs:w-full self-start flex justify-center avatar-form",on:{"submit":function($event){$event.preventDefault();return _vm.dummy.apply(null, arguments)}}},[_c('input',{ref:"inputFileElem",staticClass:"hidden",attrs:{"type":"file","accept":_vm.accept_ext.join(','),"name":"Zmień zdjęcie podopiecznego"},on:{"change":_vm.onInputChange}})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }